import BuildConfig from '$extensionSrc/buildConfig'

import { ControlStageKey } from '../utils/enums'

export const AUTOMATION_STAGE_STATUSES = {
  INITIALIZING_PLAYBOOK: {
    title: `${BuildConfig.TENANT_NAME} is initializing your checklist...`,
    body: "Don't worry, we're just checking that everything looks right!",
  },
  CHANGING_PAGES: {
    title: `${BuildConfig.TENANT_NAME} is navigating to the next setting...`,
    body: 'Please keep this tab open.',
  },
  UPDATING_SETTINGS: {
    title: `${BuildConfig.TENANT_NAME} is updating your settings...`,
    body: 'Please keep this tab open.',
  },
  UNDOING_SETTINGS: {
    title: `${BuildConfig.TENANT_NAME} is reverting your settings...`,
    body: 'Please keep this tab open.',
  },
  GATHERING_SETTINGS: {
    title: `${BuildConfig.TENANT_NAME} is checking your current settings...`,
    body: 'Please keep this tab open.',
  },
  DELETING_CHATS: {
    title: `${BuildConfig.TENANT_NAME} is deleting your chats...`,
    body: 'Please keep this window open and in focus.',
  },
  PAUSED: {
    title: `You paused this automation`,
    body: 'Click resume to continue...',
    stageKey: ControlStageKey.PAUSED,
  },
  ERRORED: {
    title: 'Something went wrong',
    body: `${BuildConfig.TENANT_NAME} was unable to find what it needed on the page to complete this action.`,
    stageKey: ControlStageKey.ERRORED,
  },
  CANCELLED: {
    title: 'Canceling',
    body: 'This should only take a few seconds.',
  },
  NEEDS_USER_INPUT: {
    title: 'This platform might need your attention',
    body: `${BuildConfig.TENANT_NAME} was interrupted by this page. If this page has a prompt, you can typically Resume once its addressed. Otherwise, contact us for support: support@blockpartyapp.com.`,
    stageKey: ControlStageKey.NEEDS_USER_INPUT,
  },
  NEEDS_USER_LOGIN: {
    title: 'Continue by logging into this platform',
    body: 'To continue, log in to the account you want to scan.',
    stageKey: ControlStageKey.NEEDS_USER_LOGIN,
  },
}
